export default "__VITE_ASSET__nvlcUOk8__"